import { createFileRoute, Link } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react"; // Import icon

export const Route = createFileRoute("/politique-confidentialite")({
  staticData: {
    // Moved routeMeta content here
    title: "Politique de Confidentialité",
    icon: <ShieldCheck className="w-5 h-5" />,
    permission: null, // Public page
    section: "Légal",
    order: 20,
  },
  component: PolitiqueConfidentialiteComponent,
});

function PolitiqueConfidentialiteComponent() {
  return (
    <div className="min-h-screen bg-base-200 p-8">
      <div className="max-w-4xl mx-auto bg-base-100 rounded-xl p-8">
        <Link to="/" className="btn btn-ghost mb-4">
          ← Retour
        </Link>
        <h1 className="text-3xl font-bold mb-6">Politique de Confidentialité</h1>
        <div className="prose">
          <p>Contenu de la politique de confidentialité à compléter...</p>
        </div>
      </div>
    </div>
  );
}
